const Nav = ({switchToLight, showCvNavButton}) =>
    <nav className={`nav ${switchToLight ? "nav--light" : ""}`}>
        <svg className="nav__logo" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0H12V24H8V0Z" fill="#63D875"/>
            <path d="M0 0H21.5L24 4H0V0Z" fill="#63D875"/>
            <path d="M8 10H18.5625L21 14H8V10Z" fill="#6EF183"/>
            <path d="M8 20H21.5631L24 24H8V20Z" fill="#6EF183"/>
        </svg>

        <a className={`button nav__button download-button ${showCvNavButton ? "nav__button--show" : ""}`} href="Toby Essex (tobysx@gmail.com) CV.pdf" download>
            <i className="fas fas fa-arrow-down" />
            &nbsp;&nbsp;&nbsp;
            Get My CV
        </a>
    </nav>;

Nav.defaultProps = {
    switchToLight: true,
    showCvNavButton: true,
};

export default Nav;
